/**
 * Detects physical mobile devices using screen.width.
 *
 * Why screen.width instead of window.innerWidth:
 * The My Models page has viewport meta tag disabled (see profile_data_controller? in shared_helper.rb),
 * so window.innerWidth returns the scaled desktop width even on mobile devices.
 * screen.width returns the actual physical screen width, allowing proper mobile detection.
 *
 * Note: This should NOT be used for responsive desktop detection - only for physical mobile devices.
 */
function isMobileDevice() {
  if (typeof window === 'undefined') return false
  return window.screen?.width < 768
}

export default isMobileDevice

